export default { 
  SET_TYPES_TRADE (state, val) {
    state.typesTrade = val
  },
}